import { c as o } from "./c.js";
import { queryElement as s } from "./utils.js";
function m(e = {}) {
  const r = {
    c: (...t) => o(r, ...t),
    use: (t, ...n) => t.install(r, ...n),
    find: s,
    context: {},
    config: e
  };
  return r;
}
export {
  m as CssRender
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/css-render@0.15.14/~/css-render/esm/CssRender.js
// module id = 876
// module chunks = 67